var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-content" },
    [
      _vm._m(0),
      _c("p", { staticClass: "text-muted mb-4" }, [
        _vm._v(
          " Informe os dados das unidades vinculadas à entidade principal para análise do credenciamento. "
        )
      ]),
      _c(
        "b-alert",
        { staticClass: "mb-4", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("h6", { staticClass: "alert-heading" }, [
              _c("i", { staticClass: "feather icon-info mr-1" }),
              _vm._v(" Informações Importantes ")
            ]),
            _c("hr"),
            _c("ul", { staticClass: "mb-0" }, [
              _c("li", [
                _c("strong", [_vm._v("Unidades Vinculadas:")]),
                _vm._v(
                  " Instituições que fazem parte do mesmo grupo ou organização"
                )
              ]),
              _c("li", [
                _c("strong", [_vm._v("Documentação:")]),
                _vm._v(
                  " Anexe os atos de credenciamento ou autorização que comprovem a vinculação, bem como o regimento interno ou estatuto."
                )
              ]),
              _c("li", [
                _c("strong", [_vm._v("Localização:")]),
                _vm._v(
                  " Informe o município e UF onde a unidade está fisicamente localizada"
                )
              ])
            ])
          ])
        ]
      ),
      !_vm.disabled
        ? _c(
            "b-card",
            {
              staticClass: "mb-4",
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c("h6", { staticClass: "mb-0" }, [
                          _c("i", {
                            staticClass:
                              "feather icon-plus-circle text-primary mr-2"
                          }),
                          _vm._v(" Adicionar Nova Unidade ")
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                2091847299
              )
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Nome da Instituição",
                            "label-for": "institutionName"
                          }
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "institutionName",
                              placeholder:
                                "Digite o nome da instituição vinculada",
                              state: _vm.getFieldState("institution_name"),
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.currentInstitution.institution_name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.currentInstitution,
                                  "institution_name",
                                  $$v
                                )
                              },
                              expression: "currentInstitution.institution_name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "CNPJ da Instituição",
                            "label-for": "institutionCnpj"
                          }
                        },
                        [
                          _c("b-form-input", {
                            directives: [
                              {
                                name: "mask",
                                rawName: "v-mask",
                                value: "##.###.###/####-##",
                                expression: "'##.###.###/####-##'"
                              }
                            ],
                            attrs: {
                              id: "institutionCnpj",
                              placeholder: "00.000.000/0000-00",
                              state: _vm.getFieldState("institution_cnpj"),
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.currentInstitution.institution_cnpj,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.currentInstitution,
                                  "institution_cnpj",
                                  $$v
                                )
                              },
                              expression: "currentInstitution.institution_cnpj"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "5" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "UF",
                            "label-for": "institutionState"
                          }
                        },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                id: "institutionState",
                                options: _vm.federationUnitList,
                                label: "name",
                                state: _vm.getFieldState("state"),
                                disabled: _vm.disabled,
                                placeholder: "Selecione o estado"
                              },
                              on: { input: _vm.selectFederationUnit },
                              model: {
                                value: _vm.currentInstitution.state,
                                callback: function($$v) {
                                  _vm.$set(_vm.currentInstitution, "state", $$v)
                                },
                                expression: "currentInstitution.state"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "no-options" },
                                  slot: "no-options"
                                },
                                [_vm._v("Nenhum registro encontrado!")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "7" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Município",
                            "label-for": "institutionCity"
                          }
                        },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                id: "institutionCity",
                                options: _vm.cityList,
                                label: "name",
                                disabled:
                                  _vm.disabled || !_vm.currentInstitution.state,
                                state: _vm.getFieldState("city"),
                                placeholder: "Selecione o município"
                              },
                              model: {
                                value: _vm.currentInstitution.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.currentInstitution, "city", $$v)
                                },
                                expression: "currentInstitution.city"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  attrs: { slot: "no-options" },
                                  slot: "no-options"
                                },
                                [_vm._v("Nenhum registro encontrado!")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("h6", { staticClass: "mt-4 mb-3 text-muted" }, [
                _vm._v("Documentação")
              ]),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Atos de Credenciamento/Autorização" }
                        },
                        [
                          _c("b-form-file", {
                            attrs: {
                              placeholder:
                                "Clique para selecionar o arquivo ou arraste aqui...",
                              "drop-placeholder": "Solte o arquivo aqui...",
                              accept: "application/pdf",
                              state: _vm.getFieldState(
                                "institution_authorization"
                              ),
                              disabled: _vm.disabled
                            },
                            model: {
                              value:
                                _vm.currentInstitution
                                  .institution_authorization,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.currentInstitution,
                                  "institution_authorization",
                                  $$v
                                )
                              },
                              expression:
                                "currentInstitution.institution_authorization"
                            }
                          }),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _c("i", {
                              staticClass: "feather icon-file-text mr-1"
                            }),
                            _vm._v(
                              " Apenas arquivos PDF. Tamanho máximo: 10MB "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Regimento Interno ou Estatuto" } },
                        [
                          _c("b-form-file", {
                            attrs: {
                              placeholder:
                                "Clique para selecionar o arquivo ou arraste aqui...",
                              "drop-placeholder": "Solte o arquivo aqui...",
                              accept: "application/pdf",
                              state: _vm.getFieldState("school_regulations"),
                              disabled: _vm.disabled
                            },
                            model: {
                              value: _vm.currentInstitution.school_regulations,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.currentInstitution,
                                  "school_regulations",
                                  $$v
                                )
                              },
                              expression:
                                "currentInstitution.school_regulations"
                            }
                          }),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _c("i", {
                              staticClass: "feather icon-file-text mr-1"
                            }),
                            _vm._v(
                              " Apenas arquivos PDF. Tamanho máximo: 10MB "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              !_vm.disabled
                ? _c(
                    "div",
                    { staticClass: "text-right mt-4" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-dynamic-primary",
                          attrs: {
                            variant: "primary",
                            disabled: !_vm.isFormValid
                          },
                          on: { click: _vm.addInstitution }
                        },
                        [
                          _c("i", { staticClass: "feather icon-plus mr-1" }),
                          _vm._v(" Adicionar Unidade ")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.linkedInstitutions.length > 0
        ? _c(
            "div",
            { staticClass: "linked-institutions-list" },
            [
              _c(
                "b-card",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function() {
                          return [
                            _c("h6", { staticClass: "mb-0" }, [
                              _c("i", {
                                staticClass:
                                  "feather icon-list text-primary mr-2"
                              }),
                              _vm._v(" Unidades Vinculadas Adicionadas ")
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    1238467289
                  )
                },
                [
                  _c(
                    "b-list-group",
                    _vm._l(_vm.linkedInstitutions, function(
                      institution,
                      index
                    ) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: index,
                          staticClass:
                            "d-flex justify-content-between align-items-start"
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-center mb-1" },
                              [
                                _c("i", {
                                  staticClass:
                                    "feather icon-building text-primary mr-2"
                                }),
                                _c("strong", [
                                  _vm._v(_vm._s(institution.institution_name))
                                ])
                              ]
                            ),
                            _c("div", { staticClass: "text-muted small" }, [
                              _vm._v(
                                " CNPJ: " +
                                  _vm._s(institution.institution_cnpj) +
                                  " | " +
                                  _vm._s(
                                    institution.city_name
                                      ? institution.city_name
                                      : ""
                                  ) +
                                  "/" +
                                  _vm._s(
                                    institution.state_short
                                      ? institution.state_short
                                      : ""
                                  ) +
                                  " "
                              )
                            ]),
                            _vm.$attrs.debug
                              ? _c(
                                  "div",
                                  { staticClass: "text-warning small mt-1" },
                                  [
                                    _c("strong", [_vm._v("DEBUG:")]),
                                    _vm._v(
                                      " Auth: " +
                                        _vm._s(
                                          !!institution.institution_authorization
                                            ? "Sim"
                                            : "Não"
                                        ) +
                                        " | School: " +
                                        _vm._s(
                                          !!institution.school_regulations
                                            ? "Sim"
                                            : "Não"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            institution.institution_authorization
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center mt-1"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-muted small" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "feather icon-file-text mr-1"
                                        }),
                                        _vm.getAuthorizationDownloadUrl(
                                          institution.institution_authorization
                                        )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "mr-1 download-link text-primary",
                                                attrs: {
                                                  href: _vm.getAuthorizationDownloadUrl(
                                                    institution.institution_authorization
                                                  ),
                                                  target: "_blank",
                                                  title:
                                                    "Baixar arquivo de autorização"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-download"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          " Atos de Credenciamento/Autorização "
                                        ),
                                        _vm.isFileObject(
                                          institution.institution_authorization
                                        )
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .institution_authorization
                                                        .name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : institution
                                              .institution_authorization
                                              .file_name
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .institution_authorization
                                                        .file_name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : institution
                                              .institution_authorization.name
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .institution_authorization
                                                        .name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            institution.school_regulations
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center mt-1"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-muted small" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "feather icon-file-text mr-1"
                                        }),
                                        _vm.getSchoolRegulationsDownloadUrl(
                                          institution.school_regulations
                                        )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "mr-1 download-link text-primary",
                                                attrs: {
                                                  href: _vm.getSchoolRegulationsDownloadUrl(
                                                    institution.school_regulations
                                                  ),
                                                  target: "_blank",
                                                  title:
                                                    "Baixar regimento interno ou estatuto"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "feather icon-download"
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(
                                          " Regimento Interno ou Estatuto "
                                        ),
                                        _vm.isFileObject(
                                          institution.school_regulations
                                        )
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .school_regulations.name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : institution.school_regulations
                                              .file_name
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .school_regulations
                                                        .file_name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : institution.school_regulations.name
                                          ? _c(
                                              "span",
                                              { staticClass: "ml-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      institution
                                                        .school_regulations.name
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          !_vm.disabled
                            ? _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "outline-danger",
                                    size: "sm"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeInstitution(institution)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "feather icon-trash-2"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Confirmar Remoção",
            centered: "",
            "hide-footer": ""
          },
          on: { hide: _vm.cancelRemove },
          model: {
            value: _vm.showRemoveConfirmModal,
            callback: function($$v) {
              _vm.showRemoveConfirmModal = $$v
            },
            expression: "showRemoveConfirmModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("i", {
              staticClass: "feather icon-trash-2 text-danger mb-2",
              staticStyle: { "font-size": "2rem" }
            }),
            _c("p", [
              _vm._v(" Tem certeza que deseja remover esta unidade vinculada? ")
            ])
          ]),
          _c(
            "div",
            { staticClass: "text-center mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "danger" },
                  on: { click: _vm.confirmRemove }
                },
                [_vm._v(" Remover ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: { click: _vm.cancelRemove }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Confirmar Continuação",
            centered: "",
            "hide-footer": ""
          },
          on: {
            hide: function($event) {
              return _vm.$emit("confirm-proceed", false)
            }
          },
          model: {
            value: _vm.showConfirmModal,
            callback: function($$v) {
              _vm.showConfirmModal = $$v
            },
            expression: "showConfirmModal"
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("i", {
              staticClass: "feather icon-alert-triangle text-warning mb-2",
              staticStyle: { "font-size": "2rem" }
            }),
            _vm.confirmationType === "no-units"
              ? _c("p", [
                  _vm._v(
                    " Você não adicionou nenhuma unidade vinculada. Deseja continuar mesmo assim? "
                  )
                ])
              : _vm.confirmationType === "partial-fields"
              ? _c("p", [
                  _vm._v(
                    " Você tem campos parcialmente preenchidos. Deseja descartar essas informações e continuar? "
                  )
                ])
              : _vm._e()
          ]),
          _c(
            "div",
            { staticClass: "text-center mt-3" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("confirm-proceed", true)
                    }
                  }
                },
                [_vm._v(" Confirmar ")]
              ),
              _c(
                "b-button",
                {
                  attrs: { variant: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("confirm-proceed", false)
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "feather icon-link mr-2" }),
      _vm._v(" Unidades Vinculadas ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }